import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Package, Anchor, Coins, PieChart } from 'lucide-react';
import styles from './WhyGambleBase.module.css';

const features = [
  {
    icon: <Shield size={32} />,
    title: 'Provable Fairness',
    description: 'Transparent and verifiable game outcomes using Solana\'s VRF'
  },
  {
    icon: <Package size={32} />,
    title: 'Modular SDK',
    description: 'Plug-and-play components for rapid gambling DApp development'
  },
  {
    icon: <Anchor size={32} />,
    title: 'Anchor-based Contracts',
    description: 'Battle-tested smart contract framework for secure deployments'
  },
  {
    icon: <Coins size={32} />,
    title: 'Token-Integrated Games',
    description: 'Native support for SPL tokens and custom tokenomics'
  },
  {
    icon: <PieChart size={32} />,
    title: 'RTP Transparency',
    description: 'Built-in analytics for return-to-player monitoring'
  }
];

const WhyGambleBase = () => {
  return (
    <section className={`${styles.whyGambleBase} section`}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className={styles.title}>Why Choose Solar?</h2>
          <p className={styles.subtitle}>
            Built with developers in mind, offering everything you need to launch successful gambling DApps
          </p>
        </motion.div>

        <div className={styles.grid}>
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className={styles.feature}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <div className={styles.iconWrapper}>
                {feature.icon}
              </div>
              <div className={styles.content}>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyGambleBase; 